import { graphql, useStaticQuery } from 'gatsby';
import { FileNode } from 'gatsby-plugin-image/dist/src/components/hooks';

type ProfileFrontMatterProps = {
  username: string;
  name: string;
  nickname?: string;
  locale?: string;
  products?: string[];
  roles?: string[];
  summary?: string;
  tags?: string[];
  profilePhoto?: FileNode;
  active: boolean;
  links?: Array<{
    type?: string;
    url?: string;
  }>;
};


export interface ProfileCardProps {
  id: string;
  frontmatter: ProfileFrontMatterProps;
}

const profilesQuery = () => {
  const data = useStaticQuery(graphql`
    query ProfilesQuery {
    profiles: allMdx(
        filter: {frontmatter: {category: {eq: "profile"}, active: {eq: true}}}
    ) {
        nodes {
        body
        id
        frontmatter {
            active
            name
            username
            category
            nickname
            locale
            tags
            summary
            roles
            products
            profilePhoto {
                childImageSharp {
                    gatsbyImageData(width: 800, placeholder: BLURRED)
                }
            }
        }
        }
    }
    }`);
  const profiles: ProfileCardProps[] = data.profiles.nodes;
  return { profiles };
};

export { profilesQuery };
